import header from "./reihe-von-ferienhaeusern.jpg";
import section1 from "./buchstapel-mit-brille.webp";
import section2 from "./ferienhaus.webp";
import section3 from "./mehrfamilien-ferienhaus.jpg";

export { header, section1, section2, section3 };
